(function ($) {
	'use strict';

	var itns = function (options) {
		var defaults = {
			nav: false,
			controlsPosition: 'bottom',
			controlsText: [
				'<svg width="14" height="24" viewBox="0 0 14 24" xmlns="http://www.w3.org/2000/svg"><path d="M13.3548 2.92647C14.0242 2.257 14.0242 1.17157 13.3548 0.502103C12.6853 -0.167368 11.5999 -0.167368 10.9304 0.502103L0.644683 10.7878C-0.00430931 11.4368 -0.0270162 12.4818 0.593173 13.1584L10.0217 23.4441C10.6615 24.142 11.7459 24.1892 12.4438 23.5494C13.1417 22.9096 13.1889 21.8252 12.5491 21.1273L4.22967 12.0516L13.3548 2.92647Z"/></svg>',
				'<svg width="14" height="24" viewBox="0 0 14 24" xmlns="http://www.w3.org/2000/svg"><path d="M0.645238 2.92647C-0.0242319 2.257 -0.0242319 1.17157 0.645238 0.502103C1.31471 -0.167368 2.40013 -0.167368 3.0696 0.502103L13.3553 10.7878C14.0043 11.4368 14.027 12.4818 13.4068 13.1584L3.97826 23.4441C3.3385 24.142 2.2541 24.1892 1.55618 23.5494C0.85826 22.9096 0.811111 21.8252 1.45087 21.1273L9.77033 12.0516L0.645238 2.92647Z"/></svg>'
			]
		};

		options = $.extend({}, defaults, options);

		var slider = tns(options);

		return slider;
	};

	if ($('.js-home-slider').length) {
		var homeSlider = itns({
			container: '.js-home-slider',
			autoplay: false,
			autoplayButtonOutput: false,
			autoplayTimeout: 6000
		});
	}

	if ($('.js-methods-slider').length) {
		var methodsSlider = itns({
			container: '.js-methods-slider',
			autoWidth: true,
			gutter: 8,
			controls: false,
			nextButton: document.getElementById('#prev')
		});

		$('.js-carousel-control[data-target="js-methods-slider"]').on('click', function () {
			var $this = $(this);

			methodsSlider.goTo($this.data('action'));
		});
	}

	if ($('.js-deposits-slider').length) {
		var depositsSlider = itns({
			container: '.js-deposits-slider',
			gutter: 8,
			controls: false,
			items: 5,
			disable: true,
			responsive: {
				1170: {
					disable: false
				}
			}
		});

		$('.js-carousel-control[data-target="js-deposits-slider"]').on('click', function () {
			var $this = $(this);

			depositsSlider.goTo($this.data('action'));
		});
	}

	if ($('.js-direct-deposits-slider').length) {
		var depositsSlider = itns({
			container: '.js-direct-deposits-slider',
			gutter: 8,
			controls: false,
			items: 5,
			disable: true,
			responsive: {
				1170: {
					disable: false
				}
			}
		});

		$('.js-carousel-control[data-target="js-direct-deposits-slider"]').on('click', function () {
			var $this = $(this);

			depositsSlider.goTo($this.data('action'));
		});
	}

	if ($('.js-withdraws-slider').length) {
		var withdrawsSlider = itns({
			container: '.js-withdraws-slider',
			gutter: 8,
			controls: false,
			items: 5,
			disable: true,
			responsive: {
				1170: {
					disable: false
				}
			}
		});

		$('.js-carousel-control[data-target="js-withdraws-slider"]').on('click', function () {
			var $this = $(this);

			withdrawsSlider.goTo($this.data('action'));
		});
	}

	if ($('.js-press-slider').length) {
		var pressSlider = itns({
			container: '.js-press-slider',
			autoWidth: true,
			gutter: 16,
			autoplay: true,
			autoplayButtonOutput: false,
			loop: $('.js-press-slider')[0].children.length > 4,
			// loop: false,
			// rewind: true,
			// center: true,
			onInit: markCurrentSlide
		});

		pressSlider.events.on('indexChanged', markCurrentSlide);
	}

	if ($('.js-reviews-slider').length) {
		var reviewsSlider = itns({
			container: '.js-reviews-slider',
			center: true,
			items: 1,
			autoHeight: false,
			fixedWidth: false,
			responsive: {
				992: {
					fixedWidth: 856,
				},
				768: {
					fixedWidth: 545,
				},
			}
		});

		reviewsSlider.events.on('indexChanged', adjacentSlidesIndexChanged)
		reviewsSlider.events.on('transitionStart', adjacentSlidesStart)
		reviewsSlider.events.on('transitionEnd', adjacentSlidesEnd)

	}

	// var pressSlider = itns({
	//     autoWidth: true,
	//     onInit: markCurrentSlide,
	// });

	// pressSlider.events.on('indexChanged', markCurrentSlide);


	function adjacentSlidesStart(info) {
		var activeSlides = []
		$.each(info.slideItems, function () {
			if ($(this).hasClass('tns-slide-active'))
				activeSlides.push($(this))
		})

		if (activeSlides.length === 3) {
			activeSlides[0].addClass('tns-slide--left')
			activeSlides[2].addClass('tns-slide--right')
		}
	}

	function adjacentSlidesIndexChanged(info) {
		$.each(info.slideItems, function () {
			$(this).removeClass('tns-slide--left tns-slide--right')
		})
	}

	function adjacentSlidesEnd(info) {
		var activeSlides = []
		$.each(info.slideItems, function () {
			if ($(this).hasClass('tns-slide-active'))
				activeSlides.push($(this))
		})
		if (activeSlides.length === 3) {
			activeSlides[0].addClass('tns-slide--left')
			activeSlides[2].addClass('tns-slide--right')
		}
	}

	function markCurrentSlide(info) {
		var indexPrev = info.indexCached,
			indexCurrent = info.index;

		if (info.slideCount <= 4) {
			info.controlsContainer.removeAttribute('style');
		}

		$(info.container).find('.tns-item').each(function (index) {
			if (index == indexCurrent) {
				$(this)
					.addClass('tns-slide-current')
					.find('.js-press-title')
					.css('opacity', 0)
					.slideDown(300)
					.animate({opacity: 1}, {queue: false, duration: 300});
			} else {
				$(this)
					.removeClass('tns-slide-current')
					.find('.js-press-title')
					.slideUp(300)
					.animate({opacity: 0}, {queue: false, duration: 300});
			}
		});
	}
})(jQuery);